(function () {
  'use strict';
  var geometryPoints = new WeakMap();
  function pointsFor(geometry) {
    if (geometryPoints.has(geometry)) return geometryPoints.get(geometry);
    var attribute = geometry.getAttribute('position');
    var points = [], seen = new Set();
    if (attribute) {
      var stride = Math.max(1, Math.floor(attribute.count / 256));
      for (var i = 0; i < attribute.count; i += stride) {
        var point = [attribute.getX(i), attribute.getY(i), attribute.getZ(i)];
        var key = point.join(',');
        if (!seen.has(key)) { seen.add(key); points.push(point); }
      }
    }
    geometryPoints.set(geometry, points);
    return points;
  }
  function hull(points) {
    if (points.length < 3) return [];
    points.sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; });
    function cross(a, b, c) { return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]); }
    var lower = [], upper = [];
    points.forEach(function (point) {
      while (lower.length > 1 && cross(lower[lower.length - 2], lower[lower.length - 1], point) <= 0) lower.pop();
      lower.push(point);
    });
    for (var i = points.length - 1; i >= 0; i--) {
      var point = points[i];
      while (upper.length > 1 && cross(upper[upper.length - 2], upper[upper.length - 1], point) <= 0) upper.pop();
      upper.push(point);
    }
    lower.pop(); upper.pop();
    return lower.concat(upper);
  }
  function mount(viewer) {
    var canvas = viewer.renderer.domElement;
    if (!viewer.host.closest('[data-studio-pdp]')) return canvas;
    if (viewer._productTouchSurface) return viewer._productTouchSurface;
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    var polygon = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
    svg.setAttribute('class', 'pdp-product-touch');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('preserveAspectRatio', 'none');
    polygon.setAttribute('class', 'pdp-product-touch__shape');
    polygon.setAttribute('fill', 'transparent');
    svg.appendChild(polygon);
    viewer.host.appendChild(svg);
    canvas.style.pointerEvents = 'none';
    canvas.style.touchAction = 'auto';
    viewer._productTouchSurface = svg;
    var pointers = new Set();
    svg.addEventListener('pointerdown', function (event) { pointers.add(event.pointerId); });
    function release(event) { pointers.delete(event.pointerId); }
    svg.addEventListener('pointerup', release);
    svg.addEventListener('pointercancel', release);
    svg.addEventListener('lostpointercapture', release);
    var previous = '', lastFrame = -Infinity;
    function update(now) {
      if (viewer._disposed || !viewer.host.isConnected) { svg.remove(); return; }
      requestAnimationFrame(update);
      if (document.hidden || now - lastFrame < 30) return;
      lastFrame = now;
      var bounds = viewer.host.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return;
      svg.setAttribute('viewBox', '0 0 ' + bounds.width + ' ' + bounds.height);
      var projected = [];
      if (viewer.product && viewer.camera) {
        viewer.product.updateWorldMatrix(true, true);
        viewer.camera.updateMatrixWorld();
        var point = viewer.product.position.clone();
        viewer.product.traverseVisible(function (mesh) {
          if (!mesh.isMesh || !mesh.geometry) return;
          pointsFor(mesh.geometry).forEach(function (vertex) {
            point.set(vertex[0], vertex[1], vertex[2]).applyMatrix4(mesh.matrixWorld).project(viewer.camera);
            if (Number.isFinite(point.x) && Number.isFinite(point.y) && point.z >= -1 && point.z <= 1) {
              projected.push([(point.x + 1) * bounds.width / 2, (1 - point.y) * bounds.height / 2]);
            }
          });
        });
      }
      var outline = hull(projected).map(function (point) { return point[0].toFixed(1) + ',' + point[1].toFixed(1); }).join(' ');
      if (outline !== previous) { polygon.setAttribute('points', outline); previous = outline; }
      if (!pointers.size) svg.style.cursor = viewer.wallMode ? 'move' : 'grab';
    }
    requestAnimationFrame(update);
    return svg;
  }
  window.AdagioProductTouch = { mount: mount };
})();
